import React from 'react';
import { ChatUIContext } from './ChatUIContext';
/**
 * Provider component that wraps its children with the UIContext.Provider
 * @public
 */
export const ChatUIContextProvider = ({
  children,
  value
}) => {
  return React.createElement(ChatUIContext.Provider, {
    value: value
  }, children);
};